import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { MatToolbar, MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { EboilerBarChartComponent } from '../eboiler-bar-chart/eboiler-bar-chart.component';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'app-boiler-room',
  templateUrl: './boiler-room.component.html',
  styleUrls: ['./boiler-room.component.scss'],
  standalone: true,
  imports: [MatToolbarModule,CommonModule,MatToolbar,MatMenuModule,MatMenu,MatButtonModule,MatIcon]
})
export class BoilerRoomComponent implements OnInit {
  @Input() tabName:any="";
  @Input() tab1:any="";
  @Input() tab2:any="";
  @Input() tab3:any="";
  @Input() tab4:any="";
  public breadcrumbsArray: any = [
    {
      page_ref: 'clients',
      page_title: 'clients'
    }
  ];
  public company_name: string;
  public showList: boolean = true;
  public emptyMsg: boolean = false;
  public today: Date;
  public eBoilerRoomApi: any = BaseUrlConstantsService.eBoilerRoomApi;
  private allSitesUrl = BaseUrlConstantsService.GET_SITES;
  private getApplicationsUrl = BaseUrlConstantsService.GET_APPLICATION;
  private deleteBoilerApi : any = BaseUrlConstantsService.eBoilerRoomApi;
  public eBoilerRoomListData: any=[];
  public clientId: any;
  public boilerName: string = "";
  public sitesList: any = [];
  public shouldShow: boolean;
  public hideItemsFromAssets: boolean = false;
  public allDeviceBoilerArray: any = [];
  public groupList: any[];
  public siteFilterValue: any =[];
  public userRoll: string;
  groupFilterValue: any[];
  public selectedSiteId: any;
  constructor(
    public router: Router,
    public service: BackendApiService,
    public activeRoute: ActivatedRoute,
  ) {
    this.utcTime();
    this.company_name = localStorage.getItem('company_name');
    if (localStorage.getItem('role') === 'ADMIN') {
      this.clientId = localStorage.getItem('admin_client_id');
    }else{
      this.clientId = localStorage.getItem('user_id');
    }
    this.userRoll = localStorage.getItem("role");
    if (this.userRoll === "USER") {
      this.company_name = localStorage.getItem("user_name");
      localStorage.setItem("company_name", this.company_name);
      this.hideItemsFromAssets = false;
    } else {
      this.hideItemsFromAssets = true;
    }

    activeRoute.queryParams.subscribe((params) => {
      console.log(params)
      this.tabName=params["tabName"];
      this.tab1 = params['tab1']
      this.tab2 = params['tab2']
      this.tab3 = params['tab3']
      this.tab4 = params['tab4']
    })
   }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  ngOnInit(): void {
    if (this.userRoll === "USER") {
      // this.clientId = localStorage.getItem("user_id");
      this.clientId = localStorage.getItem("associated_clientid") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("associated_clientid");
    } else {
      this.clientId = localStorage.getItem("admin_client_id") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("admin_client_id");
    }
    this.geteBoilerRoomData();
    this.getallSitesAndGroupsInfo(this.clientId);
  }
  goToPageLink(name: string) {
    this.router.navigate([name]);
  }
  getallSitesAndGroupsInfo(id) {
    this.service.getData(this.allSitesUrl + "/" + Math.floor(Math.random() * 90 + 10) + id + Math.floor(Math.random() * 9000 + 1000)).then((res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        this.sitesList = JSON.parse(JSON.stringify(res)).data.body;
        if (this.sitesList.length !== 0) {
          this.emptyMsg = false;
        } else {
          this.emptyMsg = true;
        }
      } else {
        this.emptyMsg = true;
        this.service.showError("Something went wrong.");
      }
    });
  }
  async getGroupsBySiteId(siteId: any) {
    let body;
    if (this.userRoll === "USER") {
      body = {
        client_id: localStorage.getItem("client_id"),
        user_id: localStorage.getItem("user_id"),
        site_id: siteId,
      };
    } else {
      body = {
        client_id: localStorage.getItem("user_id"),
        site_id: siteId,
      };
    }
    this.service
      .getData(
        this.getApplicationsUrl +
        "/" +
        this.clientId +
        "/" +
        siteId
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          this.groupList = JSON.parse(JSON.stringify(res)).data.body;
          if (this.groupList.length !== 0) {
            this.emptyMsg = false;
          } else {
            this.emptyMsg = true;
          }
        } else {
          this.service.showError("Something went wrong.");
        }
      });
  }
  //this function call site change
  onSiteSelected(id) {
    this.selectedSiteId = id;
    if(id == 0){
      localStorage.setItem("_siteId", null);
      this.siteFilterValue = [];
      //this.groupFilterValue = [];
      this.eBoilerRoomListData = this.allDeviceBoilerArray;
      if(this.eBoilerRoomListData.length != 0){
        this.emptyMsg = false;
      }else{
        this.emptyMsg = true;
      }
      this.groupList = [];
    }else{
      localStorage.setItem("_filterVal", null);
      localStorage.setItem("_searchVal", null);
      localStorage.setItem("_siteId", id);
      this.eBoilerRoomListData = this.allDeviceBoilerArray;
      this.groupList = []
      this.siteFilterValue = this.eBoilerRoomListData.filter(
              (result) => result.site_id === parseInt(id)
      );
      this.eBoilerRoomListData = this.siteFilterValue;
      if(this.eBoilerRoomListData.length === 0){
        this.emptyMsg = true;
      }else{
        this.emptyMsg = false;
      }
      this.getGroupsBySiteId(id);
    }
  }

  //on application click

  onGroupSelected(id) {
    localStorage.setItem("_searchVal", null);
    localStorage.setItem("_filterVal", null);
    localStorage.setItem("_groupId", id);
    if (parseInt(id) === 0) {
      localStorage.setItem("_siteId", null);
      this.groupFilterValue = [];
      this.eBoilerRoomListData = this.allDeviceBoilerArray;
      if (this.siteFilterValue.length != 0) {
        for (let i = 0; i < this.siteFilterValue.length; i++) {
          this.siteFilterValue = this.eBoilerRoomListData.filter(
            (result) =>
              result.site_id === parseInt(this.siteFilterValue[i].site_id)
          );
        }
        this.eBoilerRoomListData = this.siteFilterValue;
        if (this.eBoilerRoomListData.length === 0) {
          this.emptyMsg = true;
        } else {
          this.emptyMsg = false;
        }
      } else {
        this.eBoilerRoomListData = this.allDeviceBoilerArray;
        this.siteFilterValue = this.eBoilerRoomListData.filter(
          (result) => result.site_id === this.selectedSiteId
        )
        this.eBoilerRoomListData = this.siteFilterValue
        if (this.eBoilerRoomListData.length === 0) {
          this.emptyMsg = true;
        } else {
          this.emptyMsg = false;
        }
      }
    }
    else {
      // clearTimeout(this._timeOut);
      this.eBoilerRoomListData = this.allDeviceBoilerArray;
      this.groupFilterValue = this.eBoilerRoomListData.filter(
        (result) => result.application_id === parseInt(id)
      );
      this.eBoilerRoomListData = this.groupFilterValue;
      
      if (this.eBoilerRoomListData.length === 0) {
        this.emptyMsg = true;
      } else {
        this.emptyMsg = false;

      }
    }
  }

  geteBoilerRoomData(){
    this.service.getData(this.eBoilerRoomApi + 'eBoiler' + '/room/custom-TBoiler/' +  Math.floor(Math.random() * 90 + 10) + this.clientId + Math.floor(Math.random() * 9000 + 1000))
      .then(res => {
        this.eBoilerRoomListData=[];
        let response = JSON.parse(JSON.stringify(res)).data;
        if(response.status === 'success'){
          if(response.body.length != 0){
            this.emptyMsg = false;
            this.eBoilerRoomListData = response.body;
            this.allDeviceBoilerArray = this.eBoilerRoomListData;
          }else{
            this.emptyMsg = true;
          }
        }else{
          this.emptyMsg = true;
        }
      })
  }
  openBoilerRoom(id, name){
    localStorage.setItem('subsystem_id', id);
    localStorage.setItem('subsystem_name', name);
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        tabName:this.tabName,
        tab1:this.tab1,
        tab2:this.tab2,
        tab3:this.tab3,
        tab4:this.tab4,
        roomId: id,
        subsystem_name: name,
        pageRef: "eboilerRoom",
      },
    };
    this.router.navigate(['/eBoiler-room-devices'],navigationExtras);
  }
  editConfigurator(subsystem_id, name, site_name, application_name){
    const navigationExtras = {
      skipLocationChange: true,
      queryParams:{
        subsystem_id:subsystem_id, 
        boilerName: name, 
        site_name: site_name, 
        application_name:application_name,
        tabName:this.tabName,
        tab1:this.tab1,
        tab2:this.tab2,
        tab3:this.tab3,
        tab4:this.tab4,}
    };
    this.router.navigate(['boiler-configurator'],navigationExtras);
  }

  deleteBoilerFun(subsystem_id, gateway_address){
    this.service.deleteInfo(this.deleteBoilerApi + "eboiler/delete/" + subsystem_id + "/" + gateway_address)
    .then(res =>{
      let response = JSON.parse(JSON.stringify(res)).data;
      if(response.status === 'success'){
        if(response.message === 'Subsystem deleted successfully!'){
          this.geteBoilerRoomData();
        }else{
          this.service.showError('Something went wrong!');
        }
      }else{
        this.service.showError('Something went wrong!');
      }
    })
  }
}
